import React, { useState } from 'react';
import '../../styles/status-modal.css';
import axios from '../../utils/api'; 

export default function StatusModal({ userId, onClose, onPosted }) {
  const [text, setText] = useState('');
  const [bgColor, setBgColor] = useState('#1da1f2');
  const [image, setImage] = useState(null);
  const [posting, setPosting] = useState(false);
  const [imageFile, setImageFile] = useState(null);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setImage(reader.result);
//       reader.readAsDataURL(file);
//     }
//   };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file); // 💾 Store the raw file for backend
      const reader = new FileReader();
      reader.onloadend = () => setImage(URL.createObjectURL(file)); // for preview
      reader.readAsDataURL(file);
    }
  };

//   const postStatus = async () => {
//     setPosting(true);
//     const type = image ? 'image' : (text.includes('http') ? 'link' : 'text');
//     const payload = {
//       userId,
//       type,
//       content: image || text,
//       linkPreview: null
//     };
//     await axios.post('/status', payload);

//     // await fetch('/status', {
//     //   method: 'POST',
//     //   headers: { 'Content-Type': 'application/json' },
//     //   body: JSON.stringify(payload)
//     // });

//     setPosting(false);
//     onPosted(); // callback
//     onClose();  // close modal
//   };

const postStatus = async () => {
    setPosting(true);
    const formData = new FormData();
    formData.append('userId', userId);
    formData.append('type', imageFile ? 'image' : (text.includes('http') ? 'link' : 'text'));
    formData.append('content', text); // optional text
    if (imageFile) formData.append('image', imageFile);
  
    await axios.post('/status', formData);
    setPosting(false);
    onPosted();
    onClose();
  };
  

  return (
    <div className="status-modal-overlay">
      <div className="status-modal-content">
        <textarea
          style={{ backgroundColor: bgColor }}
          className="status-textarea"
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="What's your status?"
        />
        
        <div className="status-color-options">
          {['#1da1f2', '#f14668', '#48c78e', '#ffdd57'].map(color => (
            <button
              key={color}
              style={{ backgroundColor: color }}
              onClick={() => setBgColor(color)}
              className={`color-button ${bgColor === color ? 'selected' : ''}`}
            />
          ))}
        </div>

        <label className="image-upload-button">
          📷 Upload Image
          <input type="file" accept="image/*" onChange={handleImageChange} hidden />
        </label>

        {image && <img src={image} alt="preview" className="status-image-preview" />}

        <div className="status-actions">
          <button onClick={postStatus} disabled={posting}>
            {posting ? 'Posting...' : 'Post'}
          </button>
          <button onClick={onClose} className="cancel-btn">Cancel</button>
        </div>
      </div>
    </div>
  );
}
